<template>
  <div>
    <a-button type="primary" class="primary" size="small" @click="showNodetrace">
      {{ $t("businessDispatch.feedbackTransportNodeBtn") }}
    </a-button>
    <a-modal
      :title="$t('businessDispatch.feedbackTransportNodeBtn')"
      :visible="visible_nodetrace"
      :confirm-loading="confirmLoading_node"
      @cancel="cancelNodetrace"
      :afterClose="handleAfterClose"
      wrapClassName="transport-feedback-modal"
    >
      <div class="feedback-content">
        <div class="left">
          <template>
            <a-steps direction="vertical" v-model="current" style="text-align: left">
              <template v-for="(track, index) in status">
                <a-step disabled :key="index">
                  <template slot="title">
                    <span style="display: inline-block; width: 80px">{{
                      track.msg
                    }}</span>

                    <span
                      slot="description"
                      style="
                        font-size: 14px;
                        display: inline-block;
                        width: 160px;
                        margin-left: 20px;
                      "
                    >
                      {{
                        track.feedbackTime
                          ? track.feedbackTime
                          : track.titleConfig.dateHolder
                      }}
                    </span>
                    <a-button
                      type="primary"
                      v-if="current == index && !visible"
                      @click="show_arriveFactory"
                      style="margin-left: 20px"
                      >{{ $t("feedback") }}</a-button
                    >
                  </template>
                  <div slot="description" v-if="track.fileConfig" class="feedbackImgWrap">
                    <!-- selectedRows[0].boundType.code -->
                    <template
                      v-for="(config, index_conf) in track.fileConfig[boundType.code]"
                    >
                      <div
                        :key="index_conf"
                        style="display: flex; justify-content: space-between"
                      >
                        <span style="display: inline-block; width: 80px">{{
                          config.msg + "："
                        }}</span>
                        <div style="display: flex; flex-wrap: wrap; width: 300px">
                          <template v-for="(file, ind) in config.files">
                            <div
                              class="imgBg"
                              style="
                                width: 64px;
                                height: 64px;
                                position: relative;
                                margin-right: 10px;
                              "
                              :key="ind"
                            >
                              <div
                                class="imgMask"
                                style="
                                  width: 64px;
                                  height: 64px;
                                  position: absolute;
                                  display: flex;
                                  justify-content: center;
                                  align-items: center;
                                "
                              >
                                <a-icon
                                  type="eye"
                                  class="eyeIcon"
                                  @click="previewImg(config.files, file)"
                                />
                              </div>
                              <img
                                :src="file.url"
                                style="width: 100%; height: 100%"
                                class="picture"
                              />
                            </div>
                          </template>
                        </div>
                      </div>
                    </template>
                  </div>
                </a-step>
              </template>
            </a-steps>
          </template>
          <template v-if="show_feedback_weight_btn">
            <div style="margin-top: 35px">
              <div style="display: flex">
                <template>
                  <div style="paddingright: 20px">
                    <img
                      src="../../images/weight.jpg"
                      alt="weight"
                      style="width: 30px; height: 30px"
                      v-if="weightFiles.length == 0"
                    />
                    <div class="circle" v-else>✓</div>
                  </div>
                  <div style="fontsize: 16px">{{ $t("businessDispatch.Weighing") }}</div>

                  <div
                    style="font-size: 14px; margin-left: 83px"
                    v-if="weightFiles.length == 0"
                  >
                    {{ $t("businessDispatch.awaitingFeedbackWeighingInfo") }}
                  </div>
                  <div style="font-size: 14px; margin-left: 83px" v-else>
                    {{ $t("businessDispatch.hasFeedbackWeighingInfo") }}
                  </div>
                  <!-- :disabled="isFeedback" -->
                  <a-button
                    type="primary"
                    @click="show_feedback_weight()"
                    style="margin-left: 93px"
                    v-if="weightFiles.length == 0 && !visible_weight"
                  >
                    {{ $t("feedback") }}
                  </a-button>
                </template>
              </div>
              <div class="feedbackImgWrap" style="text-align: left; padding-left: 50px">
                <!-- selectedRows[0].boundType.code -->
                <template>
                  {{ $t("businessDispatch.weighingOrder") }}
                  <div style="display: flex">
                    <template v-for="(file, ind) in weightFiles">
                      <div
                        class="imgBg"
                        style="
                          width: 64px;
                          height: 64px;
                          position: relative;
                          margin-right: 10px;
                        "
                        :key="ind"
                      >
                        <div
                          class="imgMask"
                          style="
                            width: 64px;
                            height: 64px;
                            position: absolute;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                          "
                        >
                          <a-icon
                            type="eye"
                            class="eyeIcon"
                            @click="previewImg(weightFiles, file)"
                          />
                        </div>
                        <img
                          :src="file.url"
                          style="width: 100%; height: 100%"
                          class="picture"
                        />
                        <a-modal
                          :bodyStyle="{ padding: 0 }"
                          wrapClassName="attachClass"
                          dialogClass="dialogClass"
                          :title="
                            (h) => {
                              return h('div', [h('span', '')]);
                            }
                          "
                          :visible="previewVisible"
                          @cancel="closeAttach"
                        >
                          <template>
                            <div :style="{ height: '100%' }">
                              <div :style="{ height: '94%' }">
                                <div class="attactment-wrap">
                                  <img
                                    @mousedown="imgMove"
                                    :src="previewImage"
                                    class="imgStyle"
                                    :style="imgStyle"
                                    ref="imageBox"
                                  />
                                </div>
                              </div>
                              <div class="attachment-footer">
                                <a-button size="small" @click="toBIgChange">
                                  <a-icon type="zoom-in" />
                                </a-button>
                                <a-button size="small" @click="toSmallChange">
                                  <a-icon type="zoom-out" />
                                </a-button>
                                <a-button size="small" @click="rotateLeft"
                                  ><a-icon type="redo"
                                /></a-button>
                              </div>
                            </div>
                          </template>

                          <template slot="footer" class="footer">
                            <a-button key="back" @click="closeAttach">
                              {{ $t("close") }}
                            </a-button>
                            <!-- <a-button type="primary" @click="mulDown">批量下载</a-button> -->
                          </template>
                        </a-modal>
                      </div>
                    </template>
                  </div>
                </template>
              </div>
            </div>
          </template>
        </div>
        <div class="right" v-if="visible || visible_weight">
          <visible-feedback
            v-if="visible"
            @close="handleClose"
            :selectedRows="selectedRows"
            :currentTrack="status[current]"
            @success="uploadSuccess"
          ></visible-feedback>
          <visible-weight
            v-if="visible_weight"
            @close="handleClose"
            :selectedRows="selectedRows"
            @success="uploadSuccess"
          ></visible-weight>
        </div>
      </div>

      <template slot="footer" class="footer">
        <a-button key="back" @click="cancelNodetrace">
          {{ $t("close") }}
        </a-button>
      </template>
    </a-modal>

    <ImagePreview ref="imagePreviewRef" />
  </div>
</template>

<script>
import ImagePreview from "../ImagePreview";
import { orderTrackStatus, containerWeighingInfo } from "../../api/business-dispatch";
import { searchReqParam } from "../../utils/searchReqParam";
import visibleFeedback from "./visible-feedback";
import visibleWeight from "./visible-weight.vue";
import { trackConfig } from "./track.config.js";

export default {
  name: "transport-feedback",
  props: {
    selectedRows: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  components: {
    ImagePreview,
    visibleFeedback,
    visibleWeight,
  },
  data() {
    return {
      trackConfig: trackConfig(),
      req: searchReqParam(),
      visible: false,
      visible_weight: false,
      visible_nodetrace: false,
      confirmLoading_node: false,
      visible_arriveFactory: false,
      previewVisible: false,
      previewImage: "",
      current: 0,
      status: [],
      rotateTimes: 0,
      multiples: 1,
      imgStyle: "",
      show_feedback_weight_btn: false,
      weightFiles: [],
      isFeedback: true,
    };
  },
  computed: {
    boundType() {
      if (this.selectedRows && this.selectedRows.length >= 1) {
        return this.selectedRows[0].boundType;
      }
      return {
        code: "null",
        msg: this.$t("businessDispatch.noExportInfo"),
      };
    },
  },
  mounted() {},
  methods: {
    handleClose() {
      this.visible = false;
      this.visible_weight = false;
    },
    // 预览照片
    previewImg(fileList, file) {
      const list = fileList.map((f) => f.url || f.imgUrl);
      const index = fileList.findIndex((f) => f === file);
      this.$refs.imagePreviewRef.open(list, index);
    },
    showNodetrace() {
      // 初始化反馈节点信息
      let trackJson = {
        trackConfig: this.trackConfig,
      };
      this.status = JSON.parse(JSON.stringify(trackJson)).trackConfig;
      if (this.selectedRows.length >= 1) {
        /**
         * 回显所有已反馈节点的信息
         */
        // 入参校验
        if (this.selectedRows[0].orderStatus.code == "CANCELLED") {
          this.$message.error(this.$t("businessDispatch.feedbackTransportNode[1]"));
          return;
        }
        if (this.selectedRows[0].trackStatus == null) {
          this.$message.error(this.$t("businessDispatch.feedbackTransportNode[2]"));
          return;
        }
        // 确定当前所在节点， 为已完成节点的下一步
        let ispickup = true;
        this.status.forEach((item, index) => {
          if (this.selectedRows[0].trackStatus.code == item.code) {
            this.current = index + 1;
            ispickup = false;
          }
        });
        if (ispickup) {
          // 如果当前处于提箱, 则重置current为0
          this.current = 0;
        }
        // 如果过磅, 反馈按钮可用
        if (this.selectedRows[0].needContainerWeighing) {
          console.log(this.selectedRows[0].needContainerWeighing);
          this.show_feedback_weight_btn = true;
        } else {
          this.show_feedback_weight_btn = false;
        }
        // 封装请求参数
        this.req.params.orderId = this.selectedRows[0].orderId;
        // 请求接口
        orderTrackStatus(this.req).then((res) => {
          let tracks = JSON.parse(res.data).data;
          // 填充节点信息
          this.current = tracks.length - 1;

          tracks.forEach((element) => {
            // console.log(element);
            this.status.forEach((ele) => {
              if (element.trackStatus.code == ele.code) {
                // 反馈时间
                ele.feedbackTime = element.feedbackTime;
                // 反馈文件
                if (ele.fileConfig) {
                  let fileConfig = ele.fileConfig[this.boundType.code];
                  element.files.forEach((file) => {
                    fileConfig.forEach((con) => {
                      if (file.fileType == con.fileType) {
                        con.files.push(file);
                      }
                    });
                  });
                }
              }
            });
          });

          this.visible_nodetrace = true;
        });
        // 封装过磅请求参数
        this.req.params.containerId = this.selectedRows[0].containerId;
        console.log(this.req);
        containerWeighingInfo(this.req).then((res) => {
          let resData = JSON.parse(res.data);
          if (resData.code != 0 || !resData.success) return;
          this.weightFiles = resData.data;
          console.log(resData.data.length);
        });
      } else {
        this.$message.error(this.$t("businessDispatch.feedbackTransportNode[0]"));
      }
    },
    cancelNodetrace() {
      this.visible_nodetrace = false;
      this.visible = false;
      this.visible_weight = false;
      this.weightFiles = [];
    },
    show_arriveFactory() {
      // this.$refs["feedback"].visible = true;
      // if(this.visible){
      // 	this.visible = false
      // 	return
      // }
      this.visible = true;
      this.visible_weight = false;
      // console.log(a);
    },
    show_feedback_weight() {
      this.visible_weight = true;
      this.visible = false;
    },
    showImg(url) {
      this.previewVisible = true;
      this.previewImage = url;
    },
    uploadSuccess(currentStatus, files, type) {
      console.log(currentStatus, files);
      if (type === "weight") {
        this.visible_weight = false;
      }
      this.showNodetrace();
    },

    // 关闭附件预览弹框
    closeAttach() {
      this.previewVisible = false;
      this.imgStyle = "";
      this.multiples = 1;
      this.rotateTimes = 0;
    },
    // 旋转图片
    rotateLeft() {
      // this.$refs.imageBox.style.transform =
      // 	"rotate(" + 90 * this.rotateTimes + "deg)";
      this.rotateTimes++;
      this.imgStyle = `transform: rotate(${90 * this.rotateTimes}deg) scale(${
        this.multiples
      })`;
      console.log(this.imgStyle);
    },
    // 放大
    toBIgChange() {
      if (this.multiples >= 2) {
        return;
      }
      this.multiples += 0.25;
      this.imgStyle = `transform: rotate(${90 * this.rotateTimes}deg) scale(${
        this.multiples
      })`;
    },
    // 缩小
    toSmallChange() {
      if (this.multiples <= 1) {
        return;
      }
      this.multiples -= 0.25;
      this.imgStyle = `transform: rotate(${90 * this.rotateTimes}deg) scale(${
        this.multiples
      })`;
    },
    // 实现图片拖拽
    imgMove(e) {
      this.cleanUpDefaultEvent(e);
      console.log("e", e.clientX, e.target.offsetLeft);
      let oImg = e.target;
      let disX = e.clientX - oImg.offsetLeft;
      let disY = e.clientY - oImg.offsetTop;
      document.onmousemove = (e) => {
        e.preventDefault();
        let left = e.clientX - disX;
        let top = e.clientY - disY;
        this.imgStyle = this.imgStyle + `left: ${left}px; top:${top}px;`;
      };
      document.onmouseup = () => {
        document.onmousemove = null;
        document.onmousemove = null;
      };
    },
    cleanUpDefaultEvent(event) {
      event = event || window.event || arguments.callee.caller.arguments[0];
      if (event.preventDefault) {
        //IE not have
        event.preventDefault();
      }
      event.returnValue = false;
    },
    handleAfterClose() {
      this.$emit("success");
    },
  },
};
</script>
<style lang="less">
.feedback-content {
  .ant-form-item-children .ant-upload-select-picture-card {
    height: 80px;
  }
}

.transport-feedback-modal {
  .ant-modal-content {
    display: inline-block;
  }
}
</style>

<style lang="less" scoped>
.imgMask:hover {
  background: black;
  opacity: 0.5;

  .eyeIcon {
    color: white;
    opacity: 1;
  }
}

.eyeIcon {
  opacity: 0;
}

.feedbackImgWrap > div {
  display: flex;
  align-items: center;
  margin-right: 6px;
  margin-bottom: 10px;
}

/deep/ .dialogClass {
  height: 80% !important;
  width: 60% !important;
}

/deep/.dialogClass .ant-modal-content {
  height: 100%;

  .ant-modal-close {
    height: 6%;
    width: 50px;
    display: flex;
    justify-content: center;
    align-items: center;

    .ant-modal-close-x {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .ant-modal-header {
    height: 6%;
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .ant-modal-body {
    height: 88%;
    overflow: hidden;

    .ant-pagination-simple .ant-pagination-simple-pager input:nth-child(1) {
      width: 40px;
    }
  }

  .ant-modal-footer {
    height: 6%;
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;

    .ant-btn {
      font-size: 12px;
    }
  }

  .imgStyle {
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 100%;
    position: absolute;
    cursor: pointer;
  }
}

.attactment-wrap {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  justify-content: center;
}

.attachment-footer {
  height: 6%;
  position: relative;
  display: flex;
  align-items: center;
  background: #c7c5c5;
  font-weight: bold;
}

// /deep/.ant-steps-item:last-child .ant-steps-item-icon {
// 	visibility: hidden;
// }
// /deep/.ant-steps-item:last-child .ant-steps-item-tail {
// 	visibility: hidden;
// }
.circle {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 1px solid #1890ff;
  color: #1890ff;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
}

.feedback-content {
  display: flex;

  .left {
    width: 450px;
  }

  .right {
    width: 450px;
    border-left: 1px solid #eaeaea;
  }
}
</style>
